// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1p49A","name":"Header_name__1QrSK","birthday":"Header_birthday__1v3ST","skeleton":"Header_skeleton__1bFbc"};